import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { BodyText, Eyebrow, SubsectionTitle } from '@if/mui'
import { Card, CardContent, Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SkipBankAccountRequestRequirements from './SkipBankAccountRequestRequirements'

interface Props {
  creditApplicationId: string
  applicantType: EApplicantType
  financingProgramId: EFinancingProgram
}

const ManualOptionBox = ({ creditApplicationId, applicantType, financingProgramId }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Eyebrow>{`${t('incomeVerification.bankAccountProcedure.option')} 2`}</Eyebrow>
            <Divider />
          </Stack>
          <SubsectionTitle>{t('incomeVerification.bankAccountProcedure.optionTwo')}</SubsectionTitle>
          <Stack spacing={1}>
            <BodyText>{t('incomeVerification.bankAccountProcedure.upload')}</BodyText>
            <SkipBankAccountRequestRequirements
              financingProgramId={financingProgramId}
              creditApplicationId={creditApplicationId}
              applicantType={applicantType}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default ManualOptionBox
